import Vue from "vue";
import { mapGetters } from "vuex";
import { getAlarmsHistorical } from "@/models/AlarmHistorical";

export const alarmMixin = Vue.extend({
  props: {
    plantsId: Array,
  },
  data() { return { setInterval: undefined, semaphore: true } },
  computed: {
    ...mapGetters(["alarmsReceived", "activedAlarmIntervalFlag", "updatedTime"]),
  },
  mounted() {
    this.setAlarms();
  },
  methods: {
    setAlarms() {
      this.getAlarms()
      if (!this.activedAlarmIntervalFlag) {
        this.setInterval = setInterval(async () => {
          if (this.semaphore) {
            this.semaphore = false;
            await this.getAlarms();
            this.semaphore = true;
          }
        }, 60000);
      }
    },
    async getAlarms() {
      let alarms = await getAlarmsHistorical({ name: "all" }); // when has the final backend, use props this.plantsId
      let finalAlarms = this.handleAlarms(alarms);
      if (alarms) this.$store.dispatch("setAlarms", finalAlarms); // put alarms on vuex
      this.$store.dispatch("setTime");
    },
    handleAlarms(alarms) {
      let plants = [];
      let equipments = [];
      alarms.forEach((e) => {
        if (!e.plant) {
          e.equipments = [];
          plants.push(e);
        } else equipments.push(e);
      });
      equipments.forEach((e) => {
        if (e.plant) {
          let plantFinded = plants.find((eq) => eq.id == e.plant);
          if (plantFinded) {
            plantFinded.equipments.push(e);
          }
        }
      });
      return plants;
    }
  },
});